import { createApp } from 'vue';
import '@/utils/i18n';
import { getI18n, setDefaultLocale } from '@tencent/iegsp-common/i18n';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import './tailwind.css';
import TDesign from 'tdesign-vue-next';
import 'tdesign-vue-next/es/style/index.css';
import { initNetworkManager } from '@/utils/request/request';
import { store, useSettingStore, usePermissionStore, useCountStore } from './store';
import '@/style/index.less';
import App from './App.vue';
import { init as initGalileo, reportEvent } from '@/utils/galileo';
import moment from 'moment';
import router from './router';
import { init as initUser } from '@/utils/initUser';
import createVReport from '@tencent/iegsp-common/tools/directive/v-report';
import createVReportclick from '@tencent/iegsp-common/tools/directive/v-reportclick';
import { removeToken } from '@tencent/iegsp-common/tools/utils/login/util';
import { checkBrowser } from './utils/checkBrowser';

// 移除smsid的信息
removeToken();

initNetworkManager();

NProgress.configure({ showSpinner: false });

const app = createApp(App);

app.use(TDesign);
app.use(store);

const settingStore = useSettingStore();

usePermissionStore().getPermission();

initGalileo(app);
app.directive(
  'report',
  createVReport(({ name, ...params }) => {
    reportEvent(name, params);
  }),
);
app.directive(
  'reportclick',
  createVReportclick(({ name, ...params }) => {
    reportEvent(name, params);
  }),
);

setTimeout(() => {
  useCountStore().getCount();
}, 200);

// 如果路由中有语言配置优先使用路由配置
setDefaultLocale(settingStore);

app.use(router);

initUser();

// default value when pass to moment.js date invalid
moment.updateLocale('en', {
  invalidDate: '',
});

// Setup async i18n messages loading
app.use(getI18n());
app.mount('#app');

checkBrowser();

window.$app = app;
